(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[310],{

/***/ "xvV+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowTailRight", function() { return ArrowTailRight; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var ArrowTailRight = function ArrowTailRight(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9228 14.609C26.8727 14.482 26.7998 14.367 26.7048 14.268L19.7298 7.304C19.5338 7.108 19.2727 7 18.9948 7C18.7177 7 18.4567 7.108 18.2598 7.304C17.8548 7.709 17.8548 8.368 18.2598 8.772L23.4727 13.968H4.03575C3.46475 13.968 2.99975 14.432 2.99975 15.002C2.99975 15.572 3.46475 16.036 4.03575 16.036H23.4727L18.2598 21.231C17.8548 21.632 17.8518 22.288 18.2598 22.7C18.4528 22.891 18.7188 22.999 18.9897 22.999C18.9948 23 18.9978 23 19.0008 22.999C19.2717 22.999 19.5378 22.89 19.7298 22.699L26.7057 15.735C26.7997 15.636 26.8727 15.522 26.9228 15.395C27.0258 15.143 27.0258 14.864 26.9228 14.609Z"
  }));
};

/***/ })

}]);